import { createAsyncThunk } from '@reduxjs/toolkit';

import { AppDispatch, RootState, ThunkExtraArgument } from '../store';

export const createAppAsyncThunk = createAsyncThunk.withTypes<{
  state: RootState;
  dispatch: AppDispatch;
  rejectValue: string;
  extra: ThunkExtraArgument;
}>();
